<template>
  <section id="ceo-introduction" class="o-section c-sec-intro" v-my-section-class>

    <!-- Background -->
    <div class="o-background" v-if="$store.state.device !== 0">
      <div class="o-background__inner">
        <my-circle class="o-background__item o-background__item--1" :variant="2"></my-circle>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">Chief Executive’s <span class="u-nobr">introduction &amp; our journey</span></h2>

      <my-tabs>
        <my-tab title="Chief Executive’s introduction" :is-active="true" class="c-sec-intro__tab-1" v-if="ceoContent">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">{{ ceoContent.title }}</h3>
            </div>
            <div class="o-panel__body" v-html="ceoContent.body"></div>
            <div class="o-panel__footer">
              <div class="o-link__btn-group">
                <my-download-button :section="'ceo-introduction'"></my-download-button>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>
        <my-tab title="Our journey">
          <my-slider class="o-slider--journey">

            <!-- SLIDE -->
            <my-slide class="o-panel--journey" :class="['o-panel--journey--' + index]" :key="index" v-for="(item, index) in journeyContent.slides">
              <div class="o-panel__header">
                <h3 class="o-panel__title">{{ item.title }}</h3>
              </div>
              <div class="o-panel__body o-panel__body--full">

                <div class="o-panel__intro" v-html="journeyContent.body"></div>

                <!-- Chart slides -->
                <template v-if="item.charts.length !== 0">
                  <div class="c-sec-intro__journey" v-for="(chart, chartIndex) in item.charts">
                    <div class="o-media">
                      <figure class="o-media__chart o-chart">
                        <figcaption class="o-chart__caption">{{ chart.title }}</figcaption>
                        <!-- Change chart setting depending on slide index -->
                        <my-chart v-if="index === 2" :color="colors[index]" :file="chart.slug" :base-start="65" :replace-na="true"></my-chart>
                        <my-chart v-else-if="index === 3" :color="colors[index]" :file="chart.slug" :chart-type="'bar'" :skew="50" :margin="{top: 20, right: 0, bottom: 40, left: 0}"></my-chart>
                        <my-chart v-else :color="colors[index]" :file="chart.slug"></my-chart>
                      </figure>

                      <div class="o-media__text-col">
                        <figure class="o-media__kpi o-kpi">
                          <span class="o-kpi__figure">{{ chart.kpi }}</span>
                          <figcaption class="o-kpi__caption">{{ chart.kpilabel }}</figcaption>
                        </figure>
                        <div class="o-media__text" v-html="chart.body"></div>
                      </div>
                    </div>
                  </div>
                  <div class="o-panel__footnote" v-if="item.footnote" v-html="item.footnote"></div>
                </template>

                <!-- Last slide template (without chart) -->
                <template v-else>
                  <div class="c-sec-intro__journey o-panel--journey--4--grid">

                    <div class="o-panel--journey--4--text">
                      <div v-html="item.footnote"></div>
                      <div class="o-link__btn-group">
                        <my-download-button :section="pdfs[index]"></my-download-button>
                      </div>
                    </div>

                    <div class="o-grid">
                      <figure class="o-grid__item">
                        <img :src="require('@/assets/images/journey-logos/investors-people.png')" :srcset="require('@/assets/images/journey-logos/investors-people.png') + ' 1x, ' + require('@/assets/images/journey-logos/investors-people@2x.png') + ' 2x'" width="256" height="86" alt="Investors in people">
                      </figure>
                      <figure class="o-grid__item">
                        <img :src="require('@/assets/images/journey-logos/sunday-times.png')" :srcset="require('@/assets/images/journey-logos/sunday-times.png') + ' 1x, ' + require('@/assets/images/journey-logos/sunday-times@2x.png') + ' 2x'" width="256" height="126" alt="Investors in people">
                      </figure>
                      <figure class="o-grid__item">
                        <img :src="require('@/assets/images/journey-logos/utility-week.png')" :srcset="require('@/assets/images/journey-logos/utility-week.png') + ' 1x, ' + require('@/assets/images/journey-logos/utility-week@2x.png') + ' 2x'" width="256" height="68" alt="Investors in people">
                      </figure>
                    </div>

                  </div>
                </template>

                <div class="o-panel__footer" v-if="index !== 4">
                  <div class="o-link__btn-group">
                    <my-download-button :section="pdfs[index]"></my-download-button>
                  </div>
                </div>
              </div>
            </my-slide>
          </my-slider>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import MyScroll from '@/components/standard/my-scroll'
import { MySectionClass } from '@/directives/my-section-class'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import MyDownloadButton from '@/components/standard/my-download-button'
import MyParallax from '@/components/standard/my-parallax'
import MyCircle from '@/components/standard/my-circle'
import MyChart from '@/components/standard/my-chart'

export default {
  name: 'my-intro',
  components: {
    MyScroll,
    MyTabs,
    MyTab,
    MyTabInner,
    MySlider,
    MySlide,
    MyDownloadButton,
    MyCircle,
    MyParallax,
    MyChart
  },
  directives: {
    MySectionClass
  },
  data () {
    return {
      colors: ['purple', 'turq', 'red', 'rust', 'orange'],
      pdfs: ['focus-safety', 'focus-network-reliability', 'focus-customer-satisfaction', 'focus-value-for-money', 'people']
    }
  },
  computed: {
    ceoContent () {
      return this.$store.state.content['ceo'] || []
    },
    journeyContent () {
      return this.$store.state.content['journey'] || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyIntro.vue?f4b65ef2